import { render, staticRenderFns } from "./AuthPasswordsEmail.vue?vue&type=template&id=5a91724d"
import script from "./AuthPasswordsEmail.vue?vue&type=script&lang=js"
export * from "./AuthPasswordsEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports